/* ============================================================
   SST SCRIPT — Rapid Marine Global JavaScript
   Namespace: SST   |   All modules IIFE-isolated
   ============================================================ */

'use strict';

const SST = window.SST || {};
window.SST = SST;

/* ── 1. STICKY NAV ─────────────────────────────────────────── */
SST.StickyNav = (function () {
  function init() {
    const nav = document.querySelector('.sst-nav');
    if (!nav) return;

    const onScroll = () => {
      nav.classList.toggle('sst-nav--scrolled', window.scrollY > 10);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  return { init };
})();

/* ── 2. MOBILE MENU ─────────────────────────────────────────── */
SST.MobileMenu = (function () {
  function init() {
    const hamburger = document.querySelector('.sst-hamburger');
    const nav = document.querySelector('.sst-nav');
    const links = document.querySelectorAll('.sst-nav__links a');
    if (!hamburger || !nav) return;

    hamburger.addEventListener('click', () => {
      const open = nav.classList.toggle('sst-nav--open');
      hamburger.setAttribute('aria-expanded', open);
    });

    links.forEach(link => {
      link.addEventListener('click', () => {
        nav.classList.remove('sst-nav--open');
        hamburger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  return { init };
})();

/* ── 3. FADE-UP SCROLL REVEAL ───────────────────────────────── */
SST.FadeUp = (function () {
  function init() {
    const targets = document.querySelectorAll('.sst-fade-up');
    if (!targets.length) return;

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('sst-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      targets.forEach(el => observer.observe(el));
    } else {
      targets.forEach(el => el.classList.add('sst-visible'));
    }
  }

  return { init };
})();

/* ── 4. TICKER ──────────────────────────────────────────────── */
SST.Ticker = (function () {
  function init() {
    const ticker = document.querySelector('.sst-ticker__inner');
    if (!ticker) return;
    // Clone items for seamless infinite scroll (CSS handles animation)
    // Pause on hover for accessibility
    ticker.parentElement.addEventListener('mouseenter', () => {
      ticker.style.animationPlayState = 'paused';
    });
    ticker.parentElement.addEventListener('mouseleave', () => {
      ticker.style.animationPlayState = 'running';
    });
  }

  return { init };
})();

/* ── 5. CONTACT FORM ────────────────────────────────────────── */
SST.ContactForm = (function () {
  function init() {
    const form = document.querySelector('.sst-contact-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      if (!btn) return;
      const original = btn.textContent;
      btn.textContent = 'Sending…';
      btn.disabled = true;

      // Shopify contact form uses native action — re-submit after UX delay
      setTimeout(() => {
        btn.textContent = original;
        btn.disabled = false;
        form.submit();
      }, 800);
    });
  }

  return { init };
})();

/* ── 6. SMOOTH SCROLL (anchor links) ───────────────────────── */
SST.SmoothScroll = (function () {
  function init() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const target = document.querySelector(this.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        const offset = 80;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    });
  }

  return { init };
})();

/* ── 7. STAGGER CHILDREN ANIMATION ─────────────────────────── */
SST.Stagger = (function () {
  function init() {
    document.querySelectorAll('[data-sst-stagger]').forEach(parent => {
      const delay = parseFloat(parent.dataset.sstStagger) || 0.1;
      Array.from(parent.children).forEach((child, i) => {
        child.style.transitionDelay = `${i * delay}s`;
      });
    });
  }

  return { init };
})();

/* ── 8. BOOT ────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function () {
  SST.StickyNav.init();
  SST.MobileMenu.init();
  SST.FadeUp.init();
  SST.Ticker.init();
  SST.ContactForm.init();
  SST.SmoothScroll.init();
  SST.Stagger.init();
});

/* Theme editor support — re-init on section load */
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function () {
    SST.FadeUp.init();
    SST.Ticker.init();
  });
}
